import React from 'react'
import { bool } from 'prop-types'
import { connect } from 'react-redux'
import { css } from '@emotion/react'

import {
  canBuy,
  hasCard,
  getCurrentInvalidSubscriptionForCart,
  isCartInitialized,
  isUserInitialized,
  isSubscriptionFetched,
  isResellerLicense,
  getCartProducts,
} from '@/store/selectors'
import { activeProduct } from '@/utils'

const infoCss = css`
  font-size: 13px;
  line-height: 17px;
  margin: 16px 0;
  opacity: 0.8;
`

const getProperCopy = (isReseller, isMissingCard, hasInvalidSubscription) => {
  switch (true) {
    case isReseller:
    default:
      return 'Subscriptions for individual products will start right after their trial periods end. Your subscriptions will renew automatically unless you cancel them.'
    case isMissingCard:
      return 'It appears that your product is not fully activated. Before you begin making purchases at Marketplace, please ensure there’s a valid credit card in your subscription.'
    case hasInvalidSubscription:
      return 'It appears that your product is not fully activated. Before you begin making purchases at Marketplace, please ensure that your subscription is properly configured.'
  }
}

const SubscriptionInfo = ({
  isMissingCard,
  hasInvalidSubscription,
  isReseller,
  isLoading,
  isEmptyCart,
}) => {
  if (isLoading || isEmptyCart) {
    return null
  }

  const copy = getProperCopy(isReseller, isMissingCard, hasInvalidSubscription)
  return <p css={infoCss}>{copy}</p>
}

const mapStateToProps = (state) => {
  const cartProducts = getCartProducts(state)
  const canUserBuy = canBuy(state)
  const isReseller = isResellerLicense(state)
  const hasActiveProductCard = hasCard(state, activeProduct)
  const currentInvalidSubscription = getCurrentInvalidSubscriptionForCart(state)

  const isLoading =
    !isCartInitialized(state) ||
    !isUserInitialized(state) ||
    !isSubscriptionFetched(state)

  const isMissingCard = canUserBuy && !hasActiveProductCard
  const hasInvalidSubscription =
    canUserBuy && hasActiveProductCard && currentInvalidSubscription

  return {
    isReseller,
    isLoading,
    isEmptyCart: !cartProducts?.length,
    isMissingCard,
    hasInvalidSubscription,
  }
}

SubscriptionInfo.propTypes = {
  isReseller: bool,
  isLoading: bool,
  isMissingCard: bool,
  hasInvalidSubscription: bool,
  isEmptyCart: bool,
}

export default connect(mapStateToProps)(SubscriptionInfo)
